import { LocalComponent } from "~/ecs/base"

export class Taken extends LocalComponent {}
